import React from 'react'
//@ts-ignore
import theme from '../../assets/images/theme.png';
const ThemeIcon = () => {
  return (
    <img src={theme} alt="dashboard" height="20" />
  )
}

export default ThemeIcon